import React, { useState } from 'react';
import {
    BellAlertIcon,
    ChevronDownIcon,
    ChevronUpIcon,
} from '@heroicons/react/20/solid';
import ActiveAlerts from './ActiveAlerts';

const ChildAlertsSummary = ({ childAlerts }) => {
    const [expanded, setExpanded] = useState(false);

    if (!childAlerts || childAlerts.length === 0) return null;

    const faultCount = childAlerts.filter((a) => a.level === 'Fault').length;
    const alarmCount = childAlerts.filter((a) => a.level === 'Alarm').length;
    const hasFault = faultCount > 0;

    const total = childAlerts.length;
    const label = `${total} child alert${total !== 1 ? 's' : ''} (${faultCount} fault${faultCount !== 1 ? 's' : ''}, ${alarmCount} alarm${alarmCount !== 1 ? 's' : ''})`;

    return (
        <div>
            <button
                onClick={() => setExpanded((prev) => !prev)}
                className={`flex w-full items-center justify-between rounded px-3 py-2 text-sm font-semibold ${
                    hasFault
                        ? 'bg-error text-error-foreground'
                        : 'bg-warning text-warning-foreground'
                }`}
            >
                <div className="flex items-center gap-2">
                    <BellAlertIcon className="h-4 w-4" />
                    {label}
                </div>
                {expanded ? (
                    <ChevronUpIcon className="h-4 w-4" />
                ) : (
                    <ChevronDownIcon className="h-4 w-4" />
                )}
            </button>
            {expanded && (
                <div className="mt-2 pl-3">
                    <ActiveAlerts
                        alertMessages={childAlerts}
                        showTitle={false}
                    />
                </div>
            )}
        </div>
    );
};

export default ChildAlertsSummary;
